/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';

import * as bank from '../data/bank.json';
import * as accountype from '../data/accountype.json';
import * as familyType from '../data/familytype.json';
import * as gendersData from '../data/genders.json';
import * as regionsData from '../data/regions.json';
import * as maritalStatusData from '../data/marital-status.json';
import * as formSaludDental from '../data/requestinfo.json';

@Injectable({
  providedIn: 'root',
})
export class DataFormService {
  dataBank = bank;
  dataFamilyType = familyType;
  dataAccountype = accountype;
  dataGender = gendersData;
  dataRegions = regionsData;
  dataMarital = maritalStatusData;
  dataFormSaludDental = formSaludDental;


  async getBanks(): Promise<any[]> {
    return this.dataBank.bank;
  }

  async getAccountype(): Promise<any[]> {
    return this.dataAccountype.typebankaccount;
  }

  async getFamilyType(): Promise<any[]> {
    return this.dataFamilyType.familyType;
  }

  async getGenders(): Promise<any[]> {
    return this.dataGender.genders;
  }

  async getRegions(): Promise<any[]> {
    return this.dataRegions.regions;
  }

  async getmaritalStatus(): Promise<any[]> {
    return this.dataMarital.maritalStatus;
  }

  async getRejectOptions(): Promise<any[]> {
    return this.dataFormSaludDental.formSaludDental;
  }
}
